import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles({
  businessName: {
    color: colors.blue.l45,
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '19px',
    letterSpacing: '0.15px',
  },
  wrapper: {
    '&:hover': {
      cursor: 'pointer',
      '& h2': {
        textDecoration: 'underline',
      },
    },
  },
});
